export enum DEFAULT_SCREENSHOT_OPTIONS {
  HEIGHT = 1080 / 2,
  WIDTH = 1920 / 2,
}
